// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.multi-select_listboxWithSelectAll__PREAI li:first-child {
  border-bottom: 1px solid var(--mui-palette-grey-300);
}`, "",{"version":3,"sources":["webpack://./../../packages/ui/dist/select/multi-select.module.css"],"names":[],"mappings":"AAAA;EACE,oDAAoD;AACtD","sourcesContent":[".listboxWithSelectAll li:first-child {\n  border-bottom: 1px solid var(--mui-palette-grey-300);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listboxWithSelectAll": `multi-select_listboxWithSelectAll__PREAI`
};
export default ___CSS_LOADER_EXPORT___;
